import { DealType } from '@enums/essential-ui/EssentialDealType';
import styled from 'styled-components';

type BadgeProps = {
  dealType?: string;
  fontSize?: number;
  backgroundColor?: string;
  isOpenedFromDealsheet?: boolean;
};

export const Badge = styled.div.attrs<BadgeProps>({
  className: 'badge',
})<BadgeProps>`
  margin: ${(props) => (props.isOpenedFromDealsheet ? '0px' : '5px')};
  padding: 5px 10px 5px 10px;
  text-transform: ${(props) => (props.isOpenedFromDealsheet ? 'none' : 'uppercase')};
  border-radius: 0.25rem !important;
  background-color: ${(props) => props.theme.palette.purple};
  font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  ${(props) =>
    props.dealType === DealType.Lease &&
    `
            background: ${props.theme.palette.blue};
        `}
  ${(props) =>
    props.dealType === DealType.Cash &&
    `
            background: ${props.theme.palette.green};
        `}
    ${(props) =>
    props.dealType === DealType.Finance &&
    `
            background: ${props.theme.palette.yellow};
        `}
    font-size: ${(props) => props.fontSize ?? `${props.theme.typography.h6}`}px
`;

type NumberBadgeProps = {
  backgroundColor?: string;
};

export const NumberBadge = styled.div.attrs({ className: 'badge' })<NumberBadgeProps>`
  background-color: ${(props) => props.backgroundColor || props.theme.palette.gray};
  width: 28px !important;
  height: 18px !important;
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  font-size: ${(props) => props.theme.typography.h5};
  font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  color: ${(props) => props.color || props.theme.palette.dusty};
  margin-top: 5px;
  padding-left: 0 !important;
  border-radius: 0.25rem;
  font-size: ${(props) => props.theme.typography.h6}px;
`;

export const LeaseBuyoutBadge = styled.div.attrs({
  className: 'badge',
})`
  padding: 5px 10px 5px 10px;
  border-radius: 0.25rem !important;
  background-color: ${(props) => props.theme.palette.infoBlue};
  font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  font-size: ${(props) => props.theme.typography.h6}px;
`;

type VehicleTypeBadgeProps = {
  isVehicleBoughtNew: boolean;
  isCpo: boolean;
};

export const VehicleTypeBadge = styled.div.attrs({ className: 'badge' })<VehicleTypeBadgeProps>`
  margin: 5px;
  padding: 5px 10px 5px 10px;
  border-radius: 0.25rem !important;
  background-color: ${(props) =>
    props.isVehicleBoughtNew
      ? props.theme.palette.text.green
      : props.isCpo
        ? props.theme.palette.cornflowerBlue
        : props.theme.palette.dusty};
  font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  font-size: ${(props) => props.theme.typography.h6}px;
`;
